var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoosterFloatingAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#543183"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_594_948)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_radial_594_948)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#00EDFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_594_948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 20.0683L21.9317 19.8333L21 20.765L20.0683 19.8333L19.8333 20.0683L20.765 21L19.8333 21.9317L20.0683 22.1667L21 21.235L21.9317 22.1667L22.1667 21.9317L21.235 21L22.1667 20.0683Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.1402 10.4684L13.0562 21.5173C12.8714 21.9183 13.165 22.3751 13.6061 22.3751H17.7263C18.123 22.3751 18.4123 22.7503 18.3121 23.1327L16.2054 31.2572C16.0465 31.8701 16.8169 32.2854 17.2409 31.8143L29.2578 18.4826C29.6144 18.0873 29.3237 17.4572 28.791 17.4715L23.4806 17.6161C23.041 17.6276 22.7359 17.1822 22.9049 16.7769L25.3882 10.8393C25.5558 10.4355 25.2565 9.99293 24.8182 10.0001L18.6773 10.1147C18.4453 10.119 18.2362 10.2564 18.1388 10.467V10.4641L18.1402 10.4684Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_594_948",
    x: -4,
    y: -6,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_594_948"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_594_948",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_594_948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21 21) scale(18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C85FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5846B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_594_948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosterFloatingAction);
export default __webpack_public_path__ + "static/media/boosterFloatingAction.8418556fea9fbd8cabafddea1b3eb334.svg";
export { ForwardRef as ReactComponent };